export class LoggingStyles {
	public dhlLoggingStyle: string | null;
	public sstnLoggingStyle: string | null;

	public constructor(parameters: Partial<LoggingStyles>) {
		this.dhlLoggingStyle = parameters.dhlLoggingStyle;
		this.sstnLoggingStyle = parameters.sstnLoggingStyle;
	}
}
